import { render, staticRenderFns } from "./PressList.vue?vue&type=template&id=d6c2c654&scoped=true"
import script from "./PressList.vue?vue&type=script&lang=js"
export * from "./PressList.vue?vue&type=script&lang=js"
import style0 from "./PressList.vue?vue&type=style&index=0&id=d6c2c654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c2c654",
  null
  
)

export default component.exports